import { Component } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { FaqSeoService } from "src/app/core/services/faq-seo.service";

@Component({
  selector: "app-sitemap",
  templateUrl: "./sitemap.component.html",
  styleUrls: ["./sitemap.component.scss"],
})
export class SitemapComponent {
  constructor(private api: FaqSeoService, private toastr: ToastrService) {}
  siteMapData: any;
  isLoading: boolean = false;
  categoryList = [
    { id: "main_page", name: "Main Page" },
    { id: "blog", name: "Blog" },
  ];
  categoryName: any;
  ngOnInit() {}

  getSiteMap() {
    this.isLoading = true;
    this.api.viewSiteMap(this.categoryName).subscribe(
      (res: any) => {
        this.siteMapData = res;
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  downloadXml() {
    this.api.downloadSitemapXml(this.categoryName).subscribe((res: any) => {
      var element = document.createElement("a");
      var blob = new Blob([res], {
        type: "text/xml",
      });
      var url = URL.createObjectURL(blob);
      element.href = url;
      element.setAttribute("download", "sitemap.xml");
      document.body.appendChild(element);
      element.click();
    });
  }

  publishXml() {
    this.api.publishXml(this.categoryName).subscribe((res) => {
      this.toastr.success("Sitemap published successfully", "Success");
    });
  }
  selectCategory(category: any) {
    console.log(category);
  }
}
